import { ZodSchema, z } from "zod";
import { BaseOutputSchema } from "@/Schemas/BaseOutput";

export const getBaseFilterOutput = <T>(schema: ZodSchema<T>) => {
    return BaseOutputSchema.extend({
        items: z.array(schema).default([]),
        count: z.number().default(0),
    });
}